export class CompanyModel {
  companyId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  typeDocumentId: number = 0;
  document: string = '';
  digitVerification: number = 0;
  name: string = '';
  invoiceExpirationDays: number = 0;
  typeAccountingSystemId: number | null = null;
  accountingSystemId: number | null = null;
  active: boolean = true;
  deactivationDate: Date = new Date(2050, 11, 31, 23, 59, 59);
  ivaRate: number = 0;
  reteIvaRate: number = 0;
  swHelissaNiif: boolean = false;
  accountingSystemLenght: number = 10;
  creeRate: number = 0;
  ilimitadaTypeCree: string | null = null;
  swIlimitadaNewVersion: boolean = false;
  swIlimitadaNewPrefix: boolean = false;
  swIlimitadaExchangeRate: boolean = false;
  openCutsAmount: number = 3;
  activeUserAmount: number = 2;
  openCashReceiptsAmount: number = 3;
  articleIdFixedQuota: number | null = null;
  conceptInvoicingIdFixedQuota: number | null = null;
  currencyId: number = 0;
  countryId: number = 0;
  invoiceDecimals: number = 0;
  swSortByInvoicingCodeGroup: boolean = false;
  conceptInvoicingIdSale: number | null = null;
  conceptInvoicingIdReplacement: number | null = null;
  articleIdDifferenceAdvanceInvoice: number | null = null;
  accessApp: boolean = false;
  companySiesaId: number | null = null;
  systemSiesaId: number | null = null;
  conniKeySiesa: string | null = null;
  conniTokenSiesa: string | null = null;
  siesaBaseAddress: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
